import { useNavigate } from 'react-router-dom';

import { Button } from '@mantine/core';

import classes from './404.module.css';

const NotFound = () => {
	const navigate = useNavigate();
	return (
		<section className={classes.page_404}>
			<div className={classes.conainter_404}>
				<div className={classes.four_zero_four_bg}>
					<h1>404</h1>
				</div>
				<div className={classes.contant_box_404}>
					<h3 className={classes.h2}>Похоже, вы потерялись...</h3>
					<p>Страница, которую вы пытаетесь открыть недоступна или удалена.</p>
					<p>Войдите в систему или попробуйте позднее!</p>
					<Button onClick={() => navigate('/', { replace: true })}>Вернуться на главную</Button>
				</div>
			</div>
		</section>
	);
};

export default NotFound;
